import { Component, OnInit, Inject, Renderer2, HostListener, AfterViewInit, ViewChild, NgZone, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { NavbarService } from '../../../_services/navbar.service';
import { ThemeSettingsService } from '../../settings/theme-settings.service';
import { MenuSettingsService } from '../../settings/menu-settings.service';
import { takeUntil, map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SettingService } from 'src/app/_services/setting.service';
import { AppConstants } from 'src/app/_helpers/app.constants';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { SharedService } from 'src/app/_services/shared/shared.service';
import { ChangeDetectorRef } from '@angular/core';
import { EchoService } from '../../../_services/echo.service';
import { CommunicationService, RecentCall } from '../../../_services/communication.service';
import Swal from 'sweetalert2';

interface IncomingCall {
  id: string;
  caller: string;
  callee: string;
  direction: string;
  status: string;
  started_at: string;
  user?: string[];
  customerName?: string;
  orderId?: string;
  orderNumber?: string;
  orderData?: any;
  rootOrderData?: any;
}

const docElmWithBrowsersFullScreenFunctions = document.documentElement as HTMLElement & {
  mozRequestFullScreen(): Promise<void>;
  webkitRequestFullscreen(): Promise<void>;
  msRequestFullscreen(): Promise<void>;
};

const docWithBrowsersExitFunctions = document as Document & {
  mozCancelFullScreen(): Promise<void>;
  webkitExitFullscreen(): Promise<void>;
  msExitFullscreen(): Promise<void>;
};
@Component({
  selector: 'app-header-horizontal',
  templateUrl: './horizontal.component.html',
  styleUrls: ['./horizontal.component.css']
})
export class HorizontalComponent implements OnInit, AfterViewInit, OnDestroy {

  insideTm: any;
  outsideTm: any;
  private _unsubscribeAll: Subject<any>;
  brandName: string;
  brandLogo: string;
  public currentUser: any;
  public _themeSettingsConfig: any;
  private _menuSettingsConfig: any;
  public displayName: boolean;
  public isHeaderSearchOpen: any;
  public maximize: any;
  public search: any;
  public internationalization: any;
  public notification: any;
  public email: any;
  public title: any;
  public title$: any;
  public currentDateTime: string = '';
  public isPhoneRinging = false; // Telefonstatus für eingehende Anrufe
  public incomingCall: IncomingCall | null = null; // Daten des eingehenden Anrufs
  public notificationCount = 1; // Anzahl der Meldungen (inkl. eingehende Anrufe)
  public recentCalls: RecentCall[] = []; // Letzte 3 Anrufnummern
  public showRecentCallsPopup = false; // Popup für letzte Anrufe anzeigen
  public showCallDialog = environment.showCallDialog; // Anruf-Dialog anzeigen
  private callCacheTimeout: any = null; // Timer für Cache-Löschung
  // public collapseOne = false;
  // public collapseTwo = false;
  // public collapseThree = false;
  public selectedHeaderNavBarClass: string;
  public selectedNavBarHeaderClass: string;
  placement = 'bottom-right';

  public config: PerfectScrollbarConfigInterface = { wheelPropagation: false };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective, { static: true }) directiveRef?: PerfectScrollbarDirective;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private _renderer: Renderer2,
    private renderer: Renderer2,
    private navbarService: NavbarService,
    public authService: AuthService,
    private router: Router,
    public settingService: SettingService,
    private _menuSettingsService: MenuSettingsService,
    private _themeSettingsService: ThemeSettingsService,
    private sharedService: SharedService,
    private deviceService: DeviceDetectorService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private echoService: EchoService,
    private http: HttpClient,
    private communicationService: CommunicationService
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit() {
    const _self = this;
    
    // Initialisiere Datum und Uhrzeit
    this.updateDateTime();
    
    // Aktualisiere Datum und Uhrzeit jede Sekunde (Echtzeit)
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.ngZone.run(() => {
          this.updateDateTime();
        });
      }, 1000);
    });

    // Lade Benutzereinstellungen
    this.settingService.settings$.subscribe((settings: any) => {
      this.brandName = settings.brandName;
      this.brandLogo = settings.brandLogo;
    });

    // Lade Theme-Einstellungen
    this._themeSettingsService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config: any) => {
      this._themeSettingsConfig = config;
      this.maximize = this._themeSettingsConfig.maximize;
      this.search = this._themeSettingsConfig.search;
      this.internationalization = this._themeSettingsConfig.internationalization;
      this.notification = this._themeSettingsConfig.notification;
      this.email = this._themeSettingsConfig.email;
      // Telephony/Webhook initialisieren nur wenn aktiviert
      if (environment.telephonyEnabled) {
        this.initializePhoneService();
      }
    });

    // Lade Menu-Einstellungen
    this._menuSettingsService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config: any) => {
      this._menuSettingsConfig = config;
      this.selectedHeaderNavBarClass = this._menuSettingsConfig.selectedHeaderNavBarClass;
      this.selectedNavBarHeaderClass = this._menuSettingsConfig.selectedNavBarHeaderClass;
    });

    // Lade aktuelle Benutzerdaten
    if (localStorage.getItem('currentUser')) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }
  }

  ngAfterViewInit(): void {
    this.refreshView();
    
   
  }

  checkPermission(route) {
    //this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let permissions = this.currentUser.permissions;
    return permissions.includes(route);
  }

  handleBody(isMobile: boolean) {
    const _self = this;
    let currentBodyClassList = [];

    if (window.innerWidth < AppConstants.MOBILE_RESPONSIVE_WIDTH_HORIZONTAL && this._themeSettingsConfig.layout_style === 'horizontal') {
      currentBodyClassList = ['horizontal-layout', '2-columns', 'vertical-overlay-menu', 'menu-hide'];
      currentBodyClassList.push('fixed-navbar');
    }
    currentBodyClassList.forEach(function (c) {
      _self.renderer.addClass(document.body, c);
    });
  }

  updateDateTime() {
    const now = new Date();
    
    // Manuelle Formatierung für bessere Kontrolle
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    
    this.currentDateTime = `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`;
  }

  logout() {
    if (!localStorage.getItem('currentUser')) return;
    Swal.fire({
      title: 'Wirklich ausloggen?',
      text: 'Möchten Sie sich wirklich abmelden?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ja, ausloggen',
      cancelButtonText: 'Abbrechen',
      confirmButtonColor: '#dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.doLogout().then(res => {
          this.router.navigate(['/login']);
        }, err => {
          console.log(err);
          this.router.navigate(['/login']);
        });
      }
    });
  }

  refreshView() {
    const topHeaderElement = document.getElementsByClassName('top-header');
    const menuColorElement = document.getElementsByClassName('menu-header');
    const navigationElement = document.getElementsByClassName('menu-header');
    if (topHeaderElement) {
      if (this._themeSettingsConfig.colorTheme === 'light') {
        this._renderer.removeClass(topHeaderElement.item(0), 'navbar-dark');
        this._renderer.addClass(topHeaderElement.item(0), 'navbar-light');
      } else if (this._themeSettingsConfig.colorTheme === 'dark') {
        this._renderer.addClass(topHeaderElement.item(0), 'navbar-dark');
        this._renderer.removeClass(topHeaderElement.item(0), 'navbar-light');
      }
    }
    if (this._themeSettingsConfig.layout_style === 'horizontal') {
      this.selectedHeaderNavBarClass = this._themeSettingsConfig.color;
    } else if (this._themeSettingsConfig.layout_style === 'horizontal') {
      this.selectedHeaderNavBarClass = this._themeSettingsConfig.color;
    }
    if (navigationElement) {
      if (this._themeSettingsConfig.navigation === 'navbar-icon-right') {
        this._renderer.addClass(navigationElement.item(0), 'navbar-icon-right');
      }
    }
    if (menuColorElement) {
      if (this._themeSettingsConfig.menuColor === 'navbar-dark') {
        this._renderer.removeClass(menuColorElement.item(0), 'navbar-light');
        this._renderer.addClass(menuColorElement.item(0), 'navbar-dark');
      } else if (this._themeSettingsConfig.menuColor === 'navbar-light') {
        this._renderer.removeClass(menuColorElement.item(0), 'navbar-dark');
        this._renderer.addClass(menuColorElement.item(0), 'navbar-light');
      }
    }
    this.cdr.detectChanges();
  }

  toggleFixMenu(e) {
    if (this.document.body.classList.contains('menu-expanded')) {
      // show the left aside menu
      this.document.body.classList.remove('menu-expanded');
      this.document.body.classList.add('menu-collapsed');
    } else {
      this.document.body.classList.remove('menu-collapsed');
      this.document.body.classList.add('menu-expanded');
    }
  }
  toggleNavbar(e) {
    const navbar = this.document.getElementById('navbar-mobile');
    if (navbar.classList.contains('show')) {
      navbar.classList.remove('show');
    } else {
      navbar.classList.add('show');
    }
  }
  toggleNavigation(e) {
    const sidenav = document.getElementById('sidenav-overlay');
    const sidebarLeft = document.getElementById('sidebar-left') || document.getElementById('email-app-menu') ||
    document.getElementById('sidebar-todo');
    const contentOverlay = document.getElementById('content-overlay');
    const navbar = this.document.getElementById('navbar-mobile');

    if (this.document.body.classList.contains('menu-hide')) {
      this.document.body.classList.remove('menu-hide');
      this._renderer.removeClass(sidenav, 'd-none');
      this._renderer.addClass(sidenav, 'd-block');
      this.document.body.classList.remove('menu-close');
      this.document.body.classList.add('menu-open');
      this.document.body.classList.add('menu-expanded');
      navbar.classList.remove('show');
    } else if (!this.document.body.classList.contains('menu-hide') && !this.document.body.classList.contains('menu-open') ) {
      this.document.body.classList.add('menu-open');
      this._renderer.addClass(sidenav, 'd-block');
      this._renderer.removeClass(sidenav, 'd-none');
    } else {
      this._renderer.removeClass(sidenav, 'd-block');
      this.document.body.classList.remove('menu-open');
      this.document.body.classList.add('menu-hide');
      this._renderer.addClass(sidenav, 'd-none');
      navbar.classList.remove('show');
    }

    if (sidebarLeft) {
      this._renderer.removeClass(sidebarLeft, 'show');
      this._renderer.removeClass(contentOverlay, 'show');
    }
  }

  toggleFullScreen() {
    const toggleIcon = document.getElementsByClassName('ficon');

    if (toggleIcon.item(0).classList.contains('ft-maximize')) {
      this.openfullscreen();
      this._renderer.removeClass(toggleIcon.item(0), 'ft-maximize');
      this._renderer.addClass(toggleIcon.item(0), 'ft-minimize');
    } else if (toggleIcon.item(0).classList.contains('ft-minimize')) {
      this.closefullscreen();
      this._renderer.addClass(toggleIcon.item(0), 'ft-maximize');
      this._renderer.removeClass(toggleIcon.item(0), 'ft-minimize');
    }
  }

  openfullscreen() {
    // Trigger fullscreen
    // eslint-disable-next-line no-shadow,@typescript-eslint/no-shadow
    const docElmWithBrowsersFullScreenFunctions = document.documentElement as HTMLElement & {
      mozRequestFullScreen(): Promise<void>;
      webkitRequestFullscreen(): Promise<void>;
      msRequestFullscreen(): Promise<void>;
    };

    if (docElmWithBrowsersFullScreenFunctions.requestFullscreen) {
      docElmWithBrowsersFullScreenFunctions.requestFullscreen();
    } else if (docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen) { /* Firefox */
      docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen();
    } else if (docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen();
    } else if (docElmWithBrowsersFullScreenFunctions.msRequestFullscreen) { /* IE/Edge */
      docElmWithBrowsersFullScreenFunctions.msRequestFullscreen();
    }
  }

  closefullscreen() {
    // eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
    const docWithBrowsersExitFunctions = document as Document & {
      mozCancelFullScreen(): Promise<void>;
      webkitExitFullscreen(): Promise<void>;
      msExitFullscreen(): Promise<void>;
    };
    if (docWithBrowsersExitFunctions.exitFullscreen) {
      docWithBrowsersExitFunctions.exitFullscreen();
    } else if (docWithBrowsersExitFunctions.mozCancelFullScreen) { /* Firefox */
      docWithBrowsersExitFunctions.mozCancelFullScreen();
    } else if (docWithBrowsersExitFunctions.webkitExitFullscreen) { /* Chrome, Safari and Opera */
      docWithBrowsersExitFunctions.webkitExitFullscreen();
    } else if (docWithBrowsersExitFunctions.msExitFullscreen) { /* IE/Edge */
      docWithBrowsersExitFunctions.msExitFullscreen();
    }

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const sidenav = document.getElementById('sidenav-overlay');
    if (event.target.innerWidth <= 767) {
      this.document.body.classList.add('vertical-overlay-menu');
      this._renderer.removeClass(sidenav, 'd-block');
      this._renderer.addClass(sidenav, 'd-none');
    }
  }

  public clickSearch() {
    if (this.isHeaderSearchOpen) {
      this.isHeaderSearchOpen = false;
    } else {
      this.isHeaderSearchOpen = true;
    }
  }



  /**
   * Telefonstatus umschalten (für Demo-Zwecke)
   */
  togglePhoneStatus() {
    this.isPhoneRinging = !this.isPhoneRinging;
    if (this.isPhoneRinging) {
      // Demo-Anruf simulieren (mit Datenbank-Abfrage simuliert)
      this.incomingCall = {
        id: 'demo-call-' + Date.now(),
        caller: '+491637944060',
        callee: 'e0',
        direction: 'in',
        status: 'ringing',
        customerName: 'Max Mustermann', // Aus Datenbank: persons.first_name + last_name
        orderId: '12345',
        orderNumber: 'AUF-2024-001',
        started_at: new Date().toISOString(),
        orderData: {
          id: '12345',
          order_number: 'AUF-2024-001',
          status: 'active',
          created_at: new Date().toISOString(),
          delivery_date: '2024-12-20',
          pickup_date: '2024-12-18',
          total_amount: '299.99',
          currency: 'EUR',
          notes: 'Demo-Auftrag für eingehenden Anruf'
        },
        rootOrderData: {
          id: '67890',
          order_number: 'ROOT-2024-001',
          company_name: 'Musterfirma GmbH',
          status: 'active'
        }
      };
      this.notificationCount = 2;
      console.log('Demo-Anruf gestartet:', this.incomingCall);
      console.log('Demo Rufnummer:', this.incomingCall.caller);
      console.log('Demo Kundenname:', this.incomingCall.customerName);
    } else {
      this.incomingCall = null;
      this.notificationCount = 1;
    }
    console.log('Telefonstatus umgeschaltet:', this.isPhoneRinging ? 'Klingelt' : 'Stumm');
  }

  /**
   * Anruf annehmen
   */
  answerCall() {
    console.log('Anruf angenommen:', this.incomingCall?.id);
    this.clearIncomingCall();
  }

  /**
   * Anruf ablehnen
   */
  rejectCall() {
    console.log('Anruf abgelehnt:', this.incomingCall?.id);
    this.clearIncomingCall();
  }

  /**
   * Anruf-Popup schließen (ohne zu handeln)
   */
  dismissCall() {
    console.log('Anruf-Popup geschlossen');
    this.clearIncomingCall();
  }

  /**
   * Öffnet den Auftrag im Frontend
   */
  
  openOrder() {
    
    if (this.incomingCall?.orderId) {
      console.log('Öffne Auftrag:', this.incomingCall.orderId);
      console.log('Auftragsdaten:', this.incomingCall.orderData);
      // Navigiere zur Auftragsseite
      this.router.navigate(['/order', this.incomingCall.orderId, 'order-overview']);
      // Schließe die Benachrichtigung nach der Navigation
      //this.dismissCall();
    }
      
  }

  /**
   * Hole die letzten 3 Anrufnummern
   */
  getRecentCalls() {
    // Lade echte Daten über den CommunicationService
    this.communicationService.getRecentCalls()
      .subscribe({
        next: (response) => {
          if (response.success && response.recentCalls) {
            this.recentCalls = response.recentCalls;
            this.showRecentCallsPopup = true;
          } else {
            console.error('Fehler beim Laden der letzten Anrufe:', response.error);
            this.recentCalls = [];
            this.showRecentCallsPopup = true;
          }
        },
        error: (error) => {
          console.error('Fehler beim Laden der letzten Anrufe:', error);
          // Fallback: Zeige leere Liste
          this.recentCalls = [];
          this.showRecentCallsPopup = true;
        }
      });
  }

  /**
   * Schließe das Popup für letzte Anrufe
   */
  closeRecentCallsPopup() {
    this.showRecentCallsPopup = false;
  }

  /**
   * Generiert den ersten Buchstaben des Benutzernamens
   */
  getUserInitials(): string {
    console.log('getUserInitials called, currentUser:', this.currentUser);
    
    if (!this.currentUser) {
      console.log('No currentUser found, returning ?');
      return '?';
    }

    // Verwende displayName falls verfügbar, sonst firstname + auth_user
    let fullName = '';
    if (this.currentUser.displayName) {
      fullName = this.currentUser.displayName;
    } else if (this.currentUser.firstname && this.currentUser.auth_user) {
      fullName = `${this.currentUser.firstname} ${this.currentUser.auth_user}`;
    } else if (this.currentUser.firstname) {
      fullName = this.currentUser.firstname;
    } else if (this.currentUser.auth_user) {
      fullName = this.currentUser.auth_user;
    }

    console.log('Full name:', fullName);

    if (!fullName.trim()) {
      console.log('No full name found, returning ?');
      return '?';
    }

    // Gib nur den ersten Buchstaben zurück
    const initial = fullName.trim().charAt(0).toUpperCase();
    console.log('Generated initial:', initial);
    return initial;
  }



  /**
   * Telefonklingeln stoppen
   */
  stopPhoneRinging() {
    this.clearIncomingCall();
    console.log('Telefonklingeln gestoppt');
  }

  /**
   * Echo-Service für eingehende Anrufe initialisieren
   */
  private initializePhoneService() {
    const echo = this.echoService.getEcho();
    
    if (echo) {
      echo.channel('sipgate-calls').listen('incoming.sipgate.call', (event: any) => {
        this.handleIncomingCall(event);
      });
    }
  }

  /**
   * Behandelt eingehende Anrufe (wie in incoming-call.component)
   */
  private handleIncomingCall(event: any) {
    if (event.type === 'incoming_call' && event.call) {
      this.incomingCall = event.call;
      this.isPhoneRinging = true;
      console.log('Eingehender Anruf im Header erhalten:', event.call);
      console.log('Rufnummer:', this.incomingCall.caller);
      console.log('Kundenname aus Datenbank:', this.incomingCall.customerName);
      console.log('Auftrags-ID:', this.incomingCall.orderId);
      console.log('Auftragsnummer:', this.incomingCall.orderNumber);
      console.log('Auftragsdaten:', this.incomingCall.orderData);
      console.log('Root-Auftragsdaten:', this.incomingCall.rootOrderData);
      console.log('Alle Anrufdaten:', JSON.stringify(this.incomingCall, null, 2));
      
      // Starte Cache-Timeout Timer
      this.startCallCacheTimeout();
    }
  }

  /**
   * Startet den Timer für die automatische Cache-Löschung
   */
  private startCallCacheTimeout() {
    // Stoppe vorherigen Timer falls vorhanden
    this.clearCallCacheTimeout();
    
    // Starte neuen Timer basierend auf Environment-Konfiguration
    const timeoutMs = environment.callCacheTimeoutSeconds * 1000;
    this.callCacheTimeout = setTimeout(() => {
      this.clearIncomingCall();
    }, timeoutMs);
    
    console.log(`Cache-Timeout gestartet: ${environment.callCacheTimeoutSeconds} Sekunden`);
  }

  /**
   * Stoppt den Cache-Timeout Timer
   */
  private clearCallCacheTimeout() {
    if (this.callCacheTimeout) {
      clearTimeout(this.callCacheTimeout);
      this.callCacheTimeout = null;
    }
  }

  /**
   * Löscht den eingehenden Anruf aus dem Cache
   */
  private clearIncomingCall() {
    console.log('Anruf aus Cache gelöscht nach', environment.callCacheTimeoutSeconds, 'Sekunden');
    this.isPhoneRinging = false;
    this.incomingCall = null;
    this.notificationCount = 1;
    this.clearCallCacheTimeout();
  }

  /**
   * Cleanup beim Zerstören der Komponente
   */
  ngOnDestroy() {
    this.clearCallCacheTimeout();
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
